module.exports = "\n<ng-snotify></ng-snotify>\n\n<router-outlet></router-outlet>\n"